document.addEventListener("DOMContentLoaded",function()
{

    const btnMenu = document.querySelector("header #icono-menu");

    btnMenu.addEventListener("click",function()
    {

        const menu = document.querySelector("header .links"),
              imgMenu = document.querySelector("header #icono-menu img");

            if(menu.classList.contains("activo"))
            {

                imgMenu.setAttribute("src","https://cdn.shopify.com/s/files/1/0655/3724/5297/files/Icono_abrir_menu.png?v=1764709249");
                menu.classList.remove("activo");
                

            }else
            {

                imgMenu.setAttribute("src","https://cdn.shopify.com/s/files/1/0655/3724/5297/files/Icono_cerrar_menu.png?v=1764709249");
                menu.classList.add("activo");

            }

           

    });

    const header = document.querySelector("header.new-header");
    window.addEventListener("scroll",function()
    {

        const scrollVertical = window.scrollY;

        if(scrollVertical>=50)
            {


                header.classList.add("fixed");

                

            }else
            {

                header.classList.remove("fixed"); 

            }

    });




    const body = document.querySelector("body:not(.cart)");

    if(body)
    {
      
        
        body.addEventListener("click",function(e)
        {
        

        
            const elemento = e.target;

        
            if(elemento.classList.contains("toggle-sidecart"))
            {
            
                e.preventDefault();
                this.closest("body").classList.toggle("opencart");

            }


        });



    }

   
   

});